export default __webpack_public_path__ + "static/media/971.3d347f6e.png";